import Nullstack from 'nullstack';
export default function IconWorldWww({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-world-www",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M19.5 7a8.998 8.998 0 0 0 -7.5 -4a8.991 8.991 0 0 0 -7.484 4"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 3a16.989 16.989 0 0 0 -1.826 4"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 3a16.989 16.989 0 0 1 1.828 4.004"
  }), "   ", Nullstack.element("path", {
    d: "M19.5 17a8.998 8.998 0 0 1 -7.5 4a8.991 8.991 0 0 1 -7.484 -4"
  }), "   ", Nullstack.element("path", {
    d: "M11.5 21a16.989 16.989 0 0 1 -1.826 -4"
  }), "   ", Nullstack.element("path", {
    d: "M12.5 21a16.989 16.989 0 0 0 1.828 -4.004"
  }), "   ", Nullstack.element("path", {
    d: "M2 10l1 4l1.5 -4l1.5 4l1 -4"
  }), "   ", Nullstack.element("path", {
    d: "M17 10l1 4l1.5 -4l1.5 4l1 -4"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 10l1 4l1.5 -4l1.5 4l1 -4"
  }), " ");
}